export default function getCellAlignment(props) {
    var cellArgs = props.cellArgs, config = props.config;
    var alignment = 'left';
    if (config.align) {
        if (typeof config.align === 'function') {
            alignment = config.align(cellArgs);
        }
        if (typeof config.align === 'string') {
            alignment = config.align;
        }
    }
    return alignment;
}
